import { AxiosError } from 'axios';
import { FC, useCallback, useContext, useState } from 'react';
import {
  AuthenticationContext,
  notificationsActions,
  useAppDispatch,
  useUpdateAssociate,
} from '@vs-online-only-app/state';
import UploadProfilePicture from '../../profile-setup/steps/profile-picture/UploadProfilePicture';
import { ProfilePicture } from '../../profile-setup/steps/profile-picture/SetProfilePicture';

const EditProfileImage: FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useContext(AuthenticationContext);
  const [isBusy, setIsBusy] = useState(false);
  const updateAssociate = useUpdateAssociate();

  const handleChange = useCallback(
    async (picture: ProfilePicture) => {
      setIsBusy(true);

      try {
        if (!picture?.base64) {
          throw new Error('No picture provided');
        }

        await updateAssociate.mutateAsync({
          picture,
        });
        dispatch(
          notificationsActions.setCurrentNotification({
            message: 'Profile photo has been updated.',
            severity: 'success',
          }),
        );
      } catch (e) {
        if (e instanceof AxiosError) {
          const err = (e as AxiosError<{ message: string }>).response?.data
            ?.message;
          dispatch(
            notificationsActions.setCurrentNotification({
              message:
                typeof err === 'string'
                  ? err
                  : `Could not update Profile photo`,
              severity: 'error',
            }),
          );
        } else {
          dispatch(
            notificationsActions.setCurrentNotification({
              message: (e as Error).message,
              severity: 'error',
            }),
          );
        }
      }
      setIsBusy(false);
    },
    [dispatch, updateAssociate],
  );

  return (
    <UploadProfilePicture
      isUploading={isBusy}
      imgSrc={user?.image}
      setProfilePicture={handleChange}
    />
  );
};

export default EditProfileImage;
